import { FloatingFormItem, InputDecimal } from '@/components/_common';
import {
  TaxeCofinsCstSelect,
  TaxePisCstSelect,
} from '@/components/_common/TaxesSelect';
import { Alert, Col, Collapse, Form, FormInstance, Row } from 'antd';
import { useInvoiceFormContext } from '../../../InvoiceFormProvider';

interface Props {
  form: FormInstance;
}

const InvoiceServiceRetentionForm: React.FC<Props> = ({ form }) => {
  const { disabledFields } = useInvoiceFormContext();

  return (
    <Form form={form} preserve={false} disabled={disabledFields}>
      <Alert
        type="warning"
        description="Para que os valores de PIS/COFINS sejam enviados como Retenção, certifique-se de que a opção 'Reter PIS/COFINS' na aba Dados Gerais esteja selecionada."
        style={{ marginBottom: 24 }}
      />

      <Collapse
        destroyInactivePanel={true}
        defaultActiveKey={[
          'pis',
          'cofins',
          'csll',
          'inss',
          'irrf',
          'cpp',
          'others',
        ]}
      >
        <Collapse.Panel key="pis" header="PIS">
          <Row gutter={[24, 16]}>
            <Col xs={24}>
              <FloatingFormItem
                label="CST"
                name={['itemTaxes', 'retention', 'pisWithheldCst']}
              >
                <TaxePisCstSelect allowClear />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Alíquota"
                name={['itemTaxes', 'retention', 'pisWithheldRate']}
              >
                <InputDecimal fractions={4} max={100} />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Valor"
                name={['itemTaxes', 'retention', 'pisWithheldValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Base cálculo"
                name={['itemTaxes', 'retention', 'pisWithheldBase']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </Collapse.Panel>

        <Collapse.Panel key="cofins" header="COFINS">
          <Row gutter={[24, 16]}>
            <Col span={24}>
              <FloatingFormItem
                label="CST"
                name={['itemTaxes', 'retention', 'cofinsWithheldCst']}
              >
                <TaxeCofinsCstSelect allowClear />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Alíquota"
                name={['itemTaxes', 'retention', 'cofinsWithheldRate']}
              >
                <InputDecimal fractions={4} max={100} />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Valor"
                name={['itemTaxes', 'retention', 'cofinsWithheldValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Base cálculo"
                name={['itemTaxes', 'retention', 'cofinsWithheldBase']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </Collapse.Panel>

        <Collapse.Panel key="csll" header="CSLL">
          <Row gutter={[24, 16]}>
            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Alíquota"
                name={['itemTaxes', 'retention', 'csllWithheldRate']}
              >
                <InputDecimal fractions={4} max={100} />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Valor"
                name={['itemTaxes', 'retention', 'csllWithheldValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </Collapse.Panel>

        <Collapse.Panel key="inss" header="INSS">
          <Row gutter={[24, 16]}>
            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Alíquota"
                name={['itemTaxes', 'retention', 'inssWithheldRate']}
              >
                <InputDecimal fractions={4} max={100} />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Valor"
                name={['itemTaxes', 'retention', 'inssWithheldValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </Collapse.Panel>

        <Collapse.Panel key="irrf" header="IRRF">
          <Row gutter={[24, 16]}>
            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Alíquota"
                name={['itemTaxes', 'retention', 'irrfWithheldRate']}
              >
                <InputDecimal fractions={4} max={100} />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Valor"
                name={['itemTaxes', 'retention', 'irrfWithheldValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </Collapse.Panel>

        <Collapse.Panel key="cpp" header="CPP">
          <Row gutter={[24, 16]}>
            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Alíquota"
                name={['itemTaxes', 'retention', 'cppWithheldRate']}
              >
                <InputDecimal fractions={4} max={100} />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Valor"
                name={['itemTaxes', 'retention', 'cppWithheldValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </Collapse.Panel>

        <Collapse.Panel key="others" header="Outros">
          <Row gutter={[24, 16]}>
            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Outros valores"
                name={['itemTaxes', 'retention', 'otherWithholdings']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </Collapse.Panel>
      </Collapse>
    </Form>
  );
};

export default InvoiceServiceRetentionForm;
